import { action } from "@ember/object"
import Component from "@glimmer/component"
import type { CardStackSummary } from "@shared/models/card-stack"
import config from "cc-frontend/config/environment"
import styles from "./edit-template-menu.module.css"

interface Args {
  usedTemplates: Array<CardStackSummary> | null
  assignTemplateToCourse: Function
  createAndAssignTemplate?: Function
  goToTemplateGallery: Function
  toggleMenu?: Function
  hideCreateTemplateOption?: boolean
}

export default class CourseEditTemplateMenuComponent extends Component<Args> {
  readonly styles = styles
  blankTemplateId = config.BLANK_TEMPLATE_ID

  get hasUsedTemplates() {
    let length = this.args.usedTemplates?.length
    return length ? length > 0 : false
  }

  @action goToTemplateGallery() {
    if (this.args.toggleMenu) this.args.toggleMenu()
    this.args.goToTemplateGallery()
  }

  @action createAndAssignTemplate() {
    if (this.args.toggleMenu) this.args.toggleMenu()
    if (this.args.createAndAssignTemplate) this.args.createAndAssignTemplate()
  }

  @action assignTemplateToCourse(templateId) {
    if (this.args.toggleMenu) this.args.toggleMenu()
    this.args.assignTemplateToCourse(templateId)
  }
}
